(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('candidateTagHeaderBar', candidateTagHeaderBar);

    function candidateTagHeaderBar() {
        return {
            restrict: 'E',
            controller: candidateTagHeaderBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: "="
            },
            templateUrl: "rms/custom/candidate-tag-header-bar"
        };
    }

    function candidateTagHeaderBarCtrl() {
        var vm = this;

    }
})();